import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scroller } from 'react-scroll';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If there's a hash, scroll to that section
    if (hash) {
      const sectionId = hash.replace('#', '');
      // Small delay to ensure the page is loaded
      setTimeout(() => {
        scroller.scrollTo(sectionId, {
          smooth: true,
          offset: -80,
          duration: 500,
        });
      }, 100);
      return;
    }
    // Only scroll to top when pathname changes and there's no hash
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
